import {COVER_MAX_BYTES, coverSize} from './coverPicture.shared'
import {downloadAndResize} from './manip.web'
import {type PickerImage} from './picker.shared'

/**
 * The picture a person just chose, as something this device can keep.
 *
 * See `coverPicture.shared` for why a classroom's cover is kept here rather than
 * on a service. On the web the browser does the work: the picture is redrawn into a
 * canvas at the band's size and handed back as a data URI, at the highest quality
 * that still fits the cover's share of storage — the same routine that sizes a
 * picture for sharing, because it is the same problem (bytes that have to fit
 * somewhere), and the same reason it is borrowed rather than written again.
 */
export async function coverPicture(img: PickerImage): Promise<string> {
  const {width, height} = coverSize(img)
  const resized = await downloadAndResize({
    uri: img.path,
    width,
    height,
    mode: 'stretch',
    maxSize: COVER_MAX_BYTES,
    timeout: 20_000,
  })
  return resized.path
}
